export default "__VITE_ASSET__0fe3d01c__"